import { useQuery } from '@tanstack/react-query';
import { HealthcareFacilitiesApi } from '../../../apis/HealthcareFacilitiesApi/HealthcareFacilitiesApi';
import { IHealthcareFacilityDefaultTask } from '../HealthcareFacility';

export function useGetDefaultTasksByFacilityId(facilityId: number | undefined, enabled: boolean = true) {
    return useQuery<IHealthcareFacilityDefaultTask[]>({
        queryKey: ['defaultTasksByFacilityId', facilityId],
        queryFn: () => facilityId ? HealthcareFacilitiesApi.getDefaultTasksByFacilityId(facilityId) : Promise.resolve([]),
        enabled: enabled && facilityId !== undefined && facilityId > 0,
    });
}

